import OccupantFilterDropdown from "components/OccupantFilterDropdown";
import SC from "./style";
import CustomBreadcrumb from "components/CustomBreadcrumb";
import { Button, Tooltip } from "@InnoUI/";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { apiPost } from "api/callApi";
import { useSelector } from "react-redux";
import { showAlert } from "utils/helper";
import theme from "@theme/";
import { addCart } from "@store/cart/actions";
import { Pagination } from "antd";
import DocumentCard from "./DocumentCard";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

const DocumentSearch = () => {
  const [documentData, setDocumentData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");
  const type = searchParams.get("type");
  const searchKey = searchParams.get("searchKey");
  const [selectedItems, setSelectedItems] = useState([]);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [record, setTotalRecord] = useState();
  const [data, setData] = useState({
    partialSearch: 2,
  });

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || []
  );

  const getDocumentData = async () => {
    try {
      setIsLoading(true);
      const response = await apiPost(
        `/v1/file/search`,
        {
          projectId: projectId,
          projectType: type,
          searchKey: searchKey,
          pageSize: pageSize,
          pageNo: currentPage,
          partialSearch: data?.partialSearch == 2 ? false : true,
        },
        false
      );
      setDocumentData(response.data);
      setTotalRecord(response);
      setIsLoading(false);
    } catch (error) {
      console.log("Error", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDocumentData();
  }, [folderId, type, searchKey, pageSize, currentPage, data?.partialSearch]);

  const handleAddToCart = async () => {
    if (selectedItems.length === 0) {
      showAlert({
        title: "Warning",
        text: "Please select a file.",
        icon: "warning",
      });
      return;
    }
    const data = {
      id: currentProject.id,
      files: selectedItems,
    };
    dispatch(addCart(data));
    setSelectedItems([]);
  };

  const handlePagination = (page, pageSize) => {
    setPageSize(pageSize);
    setCurrentPage(page);
  };

  const optionData = [
    {
      id: 2,
      label: "Pattern Match",
      tooltipData:
        "Returns only those files that contain all the searched keywords, regardless of their order.",
    },
    {
      id: 1,
      label: "Full Search",
      tooltipData:
        "Returns all files that contain any of the searched keywords",
    },
  ];

  const handleChange = (property, value) => {
    // Update form data state
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  return (
    <>
      <CustomBreadcrumb />
      <SC.BodyContainerg>
        <SC.FilterContainer>
          <OccupantFilterDropdown />
        </SC.FilterContainer>
      </SC.BodyContainerg>
      <SC.SearchSummaryContainer>
        <SC.SummaryContainer>
          <SC.SearchSummary>
            <span style={{ fontWeight: "600", marginRight: "6px" }}>
              Search Summary:
            </span>
            <span
              style={{ fontStyle: "italic", color: "#555", fontSize: "11px" }}
            >
              The search is performed across the file name, original file name,
              submission notes, and document folder name.
            </span>
          </SC.SearchSummary>

          <SC.TotalRecord>
            Total records: <strong>{record?.totalCount || 0}</strong>
          </SC.TotalRecord>
          <SC.Keyword>
            Keyword: <SC.KeywordSpan>{searchKey}</SC.KeywordSpan>
          </SC.Keyword>
          <div style={{ marginLeft: "-17px" }}>
            <RadioGroup
              row
              name="partialSearch"
              value={data?.partialSearch || ""}
              onChange={(e) => handleChange("partialSearch", e.target.value)}
            >
              {optionData.map((option) => (
                <>
                  <Tooltip title={option.tooltipData} placement={"top"}>
                    <FormControlLabel
                      key={option.id}
                      value={option.id}
                      control={
                        <Radio
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 16,
                            },
                            "&.Mui-checked": {
                              color: "#EC810B",
                            },
                            margin: "0px 0px 0px 10px",
                          }}
                        />
                      }
                      label={option.label}
                    />
                  </Tooltip>
                </>
              ))}
            </RadioGroup>
          </div>
        </SC.SummaryContainer>

        {documentData?.length > 0 && selectedItems.length > 0 && (
          <Button
            caption={"Add to cart"}
            color={theme.colors.themeColor}
            fontSize="12px"
            style={{
              minWidth: "100px",
              height: "32px",
              borderRadius: "6px",
              border: `1px solid ${theme.colors.themeColor}`,
              backgroundColor: "#fff",
              color: theme.colors.themeColor,
            }}
            onClick={handleAddToCart}
          />
        )}
      </SC.SearchSummaryContainer>

      <SC.CardContainer>
        <SC.TopRow>
          <SC.RowWrapper style={{ width: "100%" }}>
            <SC.ColumnMore></SC.ColumnMore>
            <SC.ColumnDescription>Description</SC.ColumnDescription>
            <SC.ColumnSize>Size</SC.ColumnSize>
            <SC.ColumnDate>Date</SC.ColumnDate>
            <SC.ColumnCart>Cart</SC.ColumnCart>
          </SC.RowWrapper>
        </SC.TopRow>

        {documentData?.length > 0 ? (
          documentData.map((item) => (
            <React.Fragment key={item?.property}>
              <SC.Header>{item?.property}</SC.Header>
              {item?.files?.map((file) => (
                <DocumentCard
                  key={file.id}
                  file={file}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                  partialSearch={data?.partialSearch == 2 ? false : true}
                />
              ))}
            </React.Fragment>
          ))
        ) : (
          <SC.NoDataMessage>Nothing found for {searchKey}</SC.NoDataMessage>
        )}

        <Pagination
          total={record?.totalCount}
          current={currentPage}
          pageSize={pageSize}
          showSizeChanger
          pageSizeOptions={["10", "20", "50", "100"]}
          onChange={(page, size) => handlePagination(page, size)}
          style={{ padding: "20px", textAlign: "right", justifyContent: "end" }}
        />
      </SC.CardContainer>
    </>
  );
};

export default DocumentSearch;
